import React, { VFC } from 'react';

import { BANNERS_CONTAINER_CLASSNAME } from '../constants';

/** Container that must be rendered into a webapp layout and where the banners
 * will be rendered */
export const BannersContainer: VFC = () => (
  <div className={BANNERS_CONTAINER_CLASSNAME} />
);
